import { call, put, takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../action/actionTypes';
import { fetchDataSuccess, fetchDataFailure } from '../action/dataAction';
// import axios from 'axios';
import  fetchData  from '../axios';
function* fetchDataSaga() {
  try {
    // const response = yield call(axios.get, 'https://jsonplaceholder.typicode.com/posts');
    const response = yield call(fetchData);
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error.message));
  }
}

function* dataSaga() {
  yield takeEvery(actionTypes.FETCH_DATA_REQUEST, fetchDataSaga);
}

export default dataSaga;